// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guestbox[data-v-8bfb0d38]{margin:0 auto;text-align:left;font-size:15px;color:#676767}.gb-td[data-v-8bfb0d38]{padding:8px 12px}.btn[data-v-8bfb0d38]{width:48px;height:48px;line-height:1;border-radius:50%;font-size:30px;padding:4px}label[data-v-8bfb0d38]{white-space:nowrap;margin-bottom:0!important}.age[data-v-8bfb0d38]{font-size:13px}", ""]);
// Exports
module.exports = exports;
